import { useRef, useState } from "react";
import { BaseButton, Row, SizedBox } from "../CommonBaseComponents";
import { C4Text } from "../text/CustomText";
import CustomIcon from "../image/CustomIcon";
import { useClickOutside } from "../../hooks/useClickOutside";
import styled from "styled-components";
import DefaultDropdownMenu from "../dropdown/DefaultDropdownMenu";
import CheckedDropdownMenu from "../dropdown/CheckedDropdownMenu";
import { Theme } from "../../Theme";

const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export function CustomDropdownBoxButton({
    icon,
    currentValue,
    setValue,
    values,
    openedLeftSide = false,
    iconWidth = "13.5px",
    iconHeight = "12px",
    useApplyButton = false,
}) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const menuRef = useRef(null);
    useClickOutside(menuRef, () => {
        if (isMenuOpen) {
            setIsMenuOpen(false);
        }
    });

    return (
        <MenuContainer ref={menuRef}>
            <BaseButton
                padding={"9px 10px"}
                border={`1px solid ${Theme.color.gray250}`}
                borderRadius={"8px"}
                backgroundColor={Theme.color.white}
                onClick={toggleMenu}
                hoverBackgroundColor={Theme.color.neutral100}
                cursor={"pointer"}
            >
                <Row alignItem={"center"} cursor={"pointer"}>
                    <Row alignItem={"flex-start"} cursor={"pointer"}>
                        <CustomIcon iconName={icon} width={iconWidth} height={iconHeight} />
                        <SizedBox width={"7px"} cursor={"pointer"} />
                        <C4Text fontColor={Theme.color.zinc850}>
                            {
                                values.filter((v) => {
                                    return v.value === currentValue;
                                })[0]?.label
                            }
                        </C4Text>
                    </Row>
                    <SizedBox width={"4px"} />
                    <CustomIcon
                        iconName={isMenuOpen ? "chevron_up" : "chevron_down"}
                        size={"16px"}
                        cursor={"pointer"}
                    />
                </Row>
            </BaseButton>
            {isMenuOpen &&
                (useApplyButton ? (
                    <CheckedDropdownMenu
                        initValue={currentValue}
                        setValue={setValue}
                        values={values}
                        onClose={toggleMenu}
                        openedLeftSide={openedLeftSide}
                    />
                ) : (
                    <DefaultDropdownMenu
                        initValue={currentValue}
                        setValue={setValue}
                        values={values}
                        onClose={toggleMenu}
                        padding={"10px 0px"}
                        openedLeftSide={openedLeftSide}
                    />
                ))}
        </MenuContainer>
    );
}
